import { TransactionStatus } from '@principle-theorem/principle-core/interfaces';
import { ISerialisedDocumentReference } from '@principle-theorem/shared';
import { IInvoiceDimension } from '../dimensions/invoice';
import { IPracticeDimension } from '../dimensions/practice';
import { ITransactionDimension } from '../dimensions/transaction';
import { ITreatmentPlanDimension } from '../dimensions/treatment-plan';
import {
  IBaseEventFact,
  IBigQueryPaymentPracitionerSummary,
  IPatientScopedFact,
} from './common';

export interface ITransactionEventFact
  extends IPatientScopedFact,
    IBaseEventFact<string, TransactionStatus | undefined> {
  invoiceRef: ISerialisedDocumentReference;
  practiceRef: ISerialisedDocumentReference;
  treatmentPlanRef?: ISerialisedDocumentReference;
  transactionRef: ISerialisedDocumentReference;
  invoice: IInvoiceDimension;
  practice: IPracticeDimension;
  treatmentPlan?: ITreatmentPlanDimension;
  transaction: ITransactionDimension;
  practitionerPayments: IBigQueryPaymentPracitionerSummary[];
}
